/**
 * Recurring self-enrollment kill switch. Production stays off unless
 * `billing.selfEnrollment.enabled` is explicitly true. One-time checkout,
 * invoices, current subscription display, and cancellation are unaffected.
 */
export function isBillingSelfEnrollmentEnabled(
  config?: { enabled?: boolean } | boolean | null
): boolean {
  if (config === true) {
    return true;
  }
  if (config === false) {
    return false;
  }
  if (
    config != null &&
    typeof config === "object" &&
    typeof config.enabled === "boolean"
  ) {
    return config.enabled;
  }
  return process.env.NODE_ENV !== "production";
}

/**
 * Recurring `self.subscription.change`. Production stays off unless
 * `billing.selfEnrollment.planChange` is explicitly true. Compensation
 * and version fencing must stay GREEN before enabling in production.
 */
export function isBillingSelfPlanChangeEnabled(
  config?: { enabled?: boolean; planChange?: boolean } | boolean | null
): boolean {
  if (config === true) {
    return true;
  }
  if (config === false) {
    return false;
  }
  if (config != null && typeof config === "object") {
    if (typeof config.planChange === "boolean") {
      return config.planChange;
    }
    if (typeof config.enabled === "boolean") {
      return config.enabled;
    }
  }
  return process.env.NODE_ENV !== "production";
}
